import Cookies from 'js-cookie';

import { ACCESS_TOKEN_KEY } from '../constants';

export function getAccessToken() {
  try {
    return Cookies.get(ACCESS_TOKEN_KEY);
  } catch (e) {
    window?.newrelic?.noticeError(e as Error, { message: 'getAccessToken' });
  }
}
